var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header3"),
      _vm._v(" "),
      _c("project-info", {
        attrs: {
          projectId: parseInt(_vm.$route.query.projectId),
          trainingId: parseInt(_vm.$route.query.trainingId)
        }
      }),
      _vm._v(" "),
      _c("footer1")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f0a14556", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0a14556","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/usercenter/ProjectDetail.vue
// module id = null
// module chunks = 